import {
    accommodationInventoryIdFactory,
    accommodationInventoryIdZodSchema,
} from "@@/shared/acquire/accommodation-inventory-id";
import { resourcePickerEnabledZodSchema } from "@@/shared/acquire/resource-references/resource-reference";
import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { z } from "zod";

// Accommodation Inventory
const accommodationInventoryZodObject = z.object({
    _id: accommodationInventoryIdZodSchema,
    _type: z.literal("ACCOMMODATION_INVENTORY"),
    _createdAt: isoAndUnixZodSchema,

    groupId: resourceIdZodSchema,

    title: translatableZodSchema,
    description: translatableZodSchema,

    resourcePickerEnabled: resourcePickerEnabledZodSchema,
    displayResourceTitle: z.boolean().optional(),
});
type AccommodationInventory = z.infer<typeof accommodationInventoryZodObject>;

// Factory
const _accommodationInventoryFactoryParamsZodObject =
    accommodationInventoryZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

type FactoryParams = z.infer<
    typeof _accommodationInventoryFactoryParamsZodObject
>;
const accommodationInventoryFactory = (params: FactoryParams) => {
    const command: AccommodationInventory = {
        ...params,
        _id: accommodationInventoryIdFactory(),
        _type: "ACCOMMODATION_INVENTORY",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export { accommodationInventoryFactory, accommodationInventoryZodObject };
export type {
    AccommodationInventory,
    FactoryParams as AccommodationInventoryFactoryParams,
};
